/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the semantic type of an investigation result value option.
 */
export enum ResultValueOptionType {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    OTHERS = 'others',
}
